<template>
  
  <subshell :breadcrumbs="breadcrumbs">

    <v-tabs class="mb-12">

      <v-tab
        :text="$t('titles.general')"
        :to="{name: 'userDetail', params: {userID}}"
      />

      <v-tab
        :text="$t('titles.solutions')"
        :to="isNew ? undefined : {name: 'userSolutions', params: {userID}}"
        :disabled="isNew"
      />

    </v-tabs>

    <router-view :user="user"></router-view>

  </subshell>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import Subshell from '../Subshell.vue'
import User from '../../../models/User'
import type { VBreadcrumbsItem } from '../../../types/vuetify'

interface Props {
  userID: number | 'new'
}

const props = defineProps<Props>()

const { t } = useI18n()
const isNew = computed<boolean>(() => props.userID === 'new')

const user = computed(() => {
  let user
  if (isNew.value) {
    user = new User()
  } else {
    user = User.query().where('ID', props.userID).with(['organization']).first()
  }
  return user
})

const breadcrumbs = computed<VBreadcrumbsItem[]>(() => {

  const breadcrumbs: VBreadcrumbsItem[] = [
    {title: t('titles.users'), to: {name: 'userIndex'}},
  ]

  if (isNew.value) {
    breadcrumbs.push({title: t('titles.create_user')})
  } else {  
    breadcrumbs.push({
      title: user.value?.username ?? '(unknown user)',
      to: {name: 'userDetail', params: {userID: props.userID}}
    })
  }

  return breadcrumbs

})

</script>
